<template>
  <div>
    <!-- <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-main">{{trans('home')}}</h3></div>
    </div> -->
    <!-- End Bread crumb -->
    <!-- Container fluid  -->
    <div class="container">
      <!-- Start Page Content -->
        <div class="form-group">
          <h1>{{trans('main_screen_title')}}</h1>
        </div>
        <div class="form-group">
          <h2>{{trans('chose_project_course')}}</h2>
        </div>
        <div class="form-group">
          <label for="courseProjectId">{{trans('chose')}}</label>
          <select id="courseProjectId" class="form-control" v-model="courseProjectId" @change="cpSelected" required>
            <option :value="c.id" :key="c.id" v-for="c in cps">{{c.name}}</option>
          </select>
        </div>
        <div :class="{invisible:!courseProjectId}">
          <div class="form-group">
            <h2>{{trans('chose_create_meeting')}}</h2>
          </div>
          <div :class="{collapse:!isProject}">
            <label for="categoryId">{{trans('choose_category')}}</label>
            <select id="categoryId" class="form-control" v-model="categoryId" @change="categorySelected" required>
              <option :value="category.id" :key="category.id" v-for="category in categories">{{category.category_name}}</option>
            </select>
          </div>
          <div>
            <div class="form-group" v-if="isProject && categoryId">
              <label for="meetingSessionId">{{trans('choose_meeting_session')}}</label>
              <select id="meetingSessionId" class="form-control" v-model="meetingSessionId" @change="msSelected" required>
                <option value="new_session">{{trans("new_session")}}</option>
                <option :value="s.id" :key="s.id" v-for="s in sessions" :disabled="new Date(s.session_date.includes('T') ? s.session_date.split('T')[0] + ' ' + s.start_time : null) > new Date()">
                  {{s.subject + ' - ' + (s.session_date.includes('T') ? new Date(s.session_date.split('T')[0]).toLocaleDateString("he-IL") : null)}}
                </option>
              </select>
            </div>
            <div class="form-group" v-else-if="!isProject && courseProjectId">
              <label for="meetingSessionId">{{trans('choose_meeting_session')}}</label>
              <select id="meetingSessionId" class="form-control" v-model="meetingSessionId" @change="msSelected" required>
                <option :value="m.m_id" :key="m.m_id" v-for="m in meetings" :disabled="new Date(m.StartDate) > new Date()">
                  {{m.m_subject + ' - ' + (m.StartDate.includes('T') ? new Date(m.StartDate.split('T')[0]).toLocaleDateString("he-IL") : null)}}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div  :class="{invisible:!meetingSessionId}">
          <div class="form-inline" style="display: flex; justify-content: space-between;">
            <h2>{{trans('fill_meeting')}}</h2>
            <label :style="{ color: color }">{{ statusName }}</label>
          </div>
          <div class="form-group">
            <p v-if="errors.length">
              <b style="color: red">{{trans("errorrs_to_fix")}}:</b>
              <ul>
                <li v-for="error in errors" style="color: red">{{ error }}</li>
              </ul>
            </p>
            <input class="form-control mb-2" :placeholder="[[trans('subject')]]" v-model="subject"/>
            <input class="form-control mb-2" :placeholder="[[trans('students_presence')]]" v-model="students" type="number"/>
            <date-picker class="form-control mb-2" v-model="date" :config="options" :disabled="disabled"/>
            <!-- <input v-else class="form-control mb-2" :placeholder="[[trans('date')]]" v-model="date" :disabled="disabled" /> -->

            <div class="form-inline mb-2">
              <!-- <input class="form-control" :placeholder="[[trans('hour')]]" v-model="start" :disabled="disabled"/> -->
              <date-picker class="form-control" :placeholder="[[trans('hour')]]" v-model="start" :config="timeOptions" :disabled="disabled"/>
              <label class="mr-sm-2">{{trans('to')}}</label>
              <!-- <input class="form-control mr-sm-2" :placeholder="[[trans('hour')]]" v-model="end" :disabled="disabled"/> -->
              <date-picker class="form-control mr-sm-2" :placeholder="[[trans('hour')]]" v-model="end" :config="timeOptions" :disabled="disabled"/>

            </div>
            <!-- <input class="form-control" :placeholder="[[trans('lecturer_comments')]]" v-model="lecturerComments" type="text"/> -->
            <textarea class="form_control rounded-0" :placeholder="[[trans('lecturer_comments')]]" v-model="lecturerComments" rows="3" style="width: 100%"/>

            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="defaultUnchecked" @change="check($event)">
              <label class="custom-control-label" for="defaultUnchecked">{{ trans('report_students_attendance') }}</label>
            </div>

            <div class="custom-control custom-checkbox mr-3 panel panel-primary" :class="{invisible:!showStudentsList}">
              <div class="panel-heading"><h3 class="panel-title" style="text-align: center; color: white">{{ trans("students_list") }}</h3></div>
              <div class="panel-body ">
                <div v-for="student in assignedStudents">
                  <input type="checkbox" class="custom-control-input" style="backgroun: transparent" :value="student.id" :id="student.id" v-model="checkedStudents">
                  <label class="custom-control-label" :for="student.id">{{ student.student_name }}</label>
                </div>
                <div v-if="!assignedStudents.length" style="text-align: center">
                  <label style="color: red">{{ trans('empty_students_list') }}</label>
                </div>
              </div>
            </div>
            <div class="details">
              <label>{{trans('confirmation')}}</label>
            </div>
            <div class="details">
              <button class="btn btn-primary btn-block" v-on:click="getLocation" :disabled="status !== '0'">{{trans('send')}}</button>
            </div>

            <div id="snackbar">{{ message }}</div>
          </div>
        </div>
      </div>
      <!-- End Page Content -->
  </div>
</template>
<script>
  /* eslint-disable */
  import Peity from 'vue-peity';
  import { localMixin } from '../../mixins/localMixin';
  import * as Datamap from 'datamaps';
  import { gmapApi } from "vue2-google-maps";
  import datePicker from 'vue-bootstrap-datetimepicker';
  import 'bootstrap/dist/css/bootstrap.css';
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
  
  // import $ from 'jquery';

  export default {
    name: 'Home',
    data() {
      return {
        message: null,
        showStudentsList: false,
        assignedStudents: [],
        checkedStudents: [],
        newDate: new Date(),
        options: {
          format: 'DD.MM.YYYY',
          useCurrent: false,
        },
        timeOptions: {
          format: 'HH:mm',
          useCurrent: true
        },
        errors: [],
        cps: [],
        meetings: [],
        sessions: [],
        categories: [],

        courseProjectId: null,
        meetingSessionId: null,
        isProject: false,
        categoryId: null,
        subject: null,
        students: null,
        date: null,
        start: null,
        end: null,
        disabled: true,
        geo: null,
        lecturerComments: null,
        status: null,
        statusName: null
      };
    },
    mixins: [localMixin],
    components: {
      Peity,
      datePicker
    },
    methods: {
      showNotification(message) {
        var x = document.getElementById("snackbar");

        x.className = "show";
        this.message = message;
        setTimeout(function() {
          x.className = x.className.replace("show", "");
          this.message = null;
          }, 3000);
      },
      async check(e) {
        if (e.target.checked) {
          this.assignedStudents = [];
          const response = await this.axios.post(this.$parent.api.host + this.$parent.api.getStudentsList, { id: this.courseProjectId, type: this.isProject ? 'project' : 'course' });
          this.assignedStudents = response.data;
        } else {
          this.assignedStudents = [];
          this.checkedStudents = [];
        }

        this.showStudentsList = e.target.checked;
      },
      async getCourses() {
        const response = await this.axios.post(this.$parent.api.host + this.$parent.api.getCoursesByLecturer);
        this.cps = this.cps.concat(response.data);
      },
      async getProjects() {
        const response = await this.axios.post(this.$parent.api.host + this.$parent.api.getProjectsByLecturer);
        this.cps = this.cps.concat(response.data);
      },
      async getCategories() {
        this.categories = [];
        const response = await this.axios.post(this.$parent.api.host + this.$parent.api.getCategoriesByProject, { id: this.courseProjectId });
        this.categories = response.data;
      },
      async cpSelected() {
        this.categories = null;
        this.categoryId = null;
        this.meetingSessionId = null;
        this.subject = null;
        this.students = null;
        this.date = null;
        this.start = null;
        this.end = null;
        this.lecturerComments = null;
        this.status = null;
        this.statusName = null;
        this.assignedStudents = [];
        this.checkedStudents = [];
        this.showStudentsList = false;
        document.getElementById("defaultUnchecked").checked = false;
        
        const json = this.cps.find((item, i) => {
          return item.id === this.courseProjectId;
        });

        if (json.type === "course") {
          this.isProject = false;
          this.meetings = [];
          const response = await this.axios.post(this.$parent.api.host + this.$parent.api.getMeetingsByCourseLecturer, { id: this.courseProjectId });
          this.meetings = response.data;
        } else {
          this.isProject = true;
          this.getCategories();
        }
      },
      async msSelected() {
        this.errors = [];
        if (!this.meetingSessionId) return;
        if (this.isProject) {
          if (this.meetingSessionId === "new_session") {
            this.subject = null;
            this.disabled = false;
            this.students = null;
            this.date = new Date();
            this.start = null;
            this.end = null;
            this.lecturerComments = null;
            this.status = '0';
            this.statusName = 'מתוכנן';
          } else {
            this.disabled = true;

            const json = this.sessions.find((item, i) => {
              return item.id === this.meetingSessionId;
            });

            this.status = json.status;
            this.statusName = json.status_name;
            this.subject = json.subject;
            this.students = json.students === undefined ? null : (json.students > 0 ? json.students : null);
            this.date = json.session_date.includes('T') ? new Date(json.session_date.split('T')[0]).toLocaleDateString("he-IL") : null;
            this.start = json.start_time;
            this.end = json.end_time;
            this.lecturerComments = json.lecturer_comments;
          }
        } else {
          this.disabled = true;
          const json = this.meetings.find((item, i) => {
            return item.m_id === this.meetingSessionId;
            });

          this.status = json.m_cancelled;
          this.statusName = json.status_name;
          this.subject = json.m_subject;
          this.students = json.students === undefined ? null : (json.students > 0 ? json.students : null);
          this.date = json.StartDate.includes('T') ? new Date(json.StartDate.split('T')[0]).toLocaleDateString("he-IL") : null;
          this.start = json.StartDate.includes('T') ? json.StartDate.split('T')[1] : null;
          this.end = json.EndDate.includes('T') ? json.EndDate.split('T')[1] : null;
          this.lecturerComments = json.lecturer_comments;
        }

        this.assignedStudents = [];
        this.checkedStudents = [];
        this.showStudentsList = false;
        document.getElementById("defaultUnchecked").checked = false;
      },
      async categorySelected() {
        this.meetingSessionId = null;
        this.subject = null;
        this.students = null;
        this.date = null;
        this.start = null;
        this.end = null;
        this.lecturerComments = null;
        this.status = null;
        this.statusName = null;
        this.assignedStudents = [];
        this.checkedStudents = [];
        this.showStudentsList = false;
        document.getElementById("defaultUnchecked").checked = false;

        this.sessions = [];
        const response = await this.axios.post(this.$parent.api.host + this.$parent.api.getSessionsByProjectLecturerCategory, { id: this.courseProjectId, categoryId: this.categoryId });
        this.sessions = response.data;
      },
      async submitReport() {
        debugger;
        let response = null;
        if (this.meetingSessionId === 'new_session') {
          if (this.isNewSessionDetailsValid()) {
            response = await this.axios.post(
              this.$parent.api.host + this.$parent.api.submitNewReport,
              {
                projectId: this.courseProjectId,
                categoryId: this.categoryId,
                subject: this.subject ? this.subject : '',
                sessionDate: this.date,
                startTime: this.start,
                endTime: this.end,
                students: this.students ? this.students : 0,
                geo: this.geo,
                lecturerComments: this.lecturerComments
              }
            )
          }
          //  else {
          //   alert(response.data);
          // }
        } else {
          response = await this.axios.post(
            this.$parent.api.host + this.$parent.api.submitReport,
            {
              id: this.meetingSessionId,
              type: this.isProject ? 'project' : 'course',
              subject: this.subject,
              students: this.students ? this.students : 0,
              geo: this.geo,
              lecturerComments: this.lecturerComments
            });
        }

        if (response != null) {
           if (response.data > '0') {
            this.showNotification("דיווח עודכן בהצלחה");

            if (this.showStudentsList) {
              response = await this.axios.post(
              this.$parent.api.host + this.$parent.api.submitStudentsAttendance, { msDate: this.date, studentCourseProjectIds: this.checkedStudents });
              if (response != null) {
                if (response.status === 200) {
                  this.assignedStudents = [];
                  this.checkedStudents = [];
                  this.showStudentsList = false;
                  document.getElementById("defaultUnchecked").checked = false;

                  this.showNotification("דיווח נוכחות נקלט בהצלחה");
                } else {
                  this.showNotification(response.data);
                }
              }
            }

            this.courseProjectId = null;
            this.meetingSessionId = null;
            this.categories = null;
            this.categoryId = null;
            this.meetingSessionId = null;
            this.subject = null;
            this.students = null;
            this.date = null;
            this.start = null;
            this.end = null;
            this.lecturerComments = null;
            this.geo = null;
            this.status = null;
            this.statusName = null;
          }
           else {
            alert(response.data);
          }
        }
      },
      isNewSessionDetailsValid() {
        this.errors = [];
        
        if (!this.date) {
          this.errors.push(this.trans("session_date_validation"));
        }
        if (!this.start) {
          this.errors.push(this.trans("session_start_time_validation"));
        }
        if (!this.end){
          this.errors.push(this.trans("session_end_time_validation"));            
        }
        if (this.end <= this.start) {
          this.errors.push(this.trans("invalid_hours_range"));
        }
        
        if (this.errors.length)
          return false;

        return true;
      },
      getLocation() {
        if (navigator.geolocation) {
          var options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
          };
          navigator.geolocation.getCurrentPosition(this.showPosition, this.showError, options);
        }
      },
      showPosition(position) {
        // this.decodeCoord({ latitude: position.coords.latitude, longitude: position.coords.longitude });
        this.geo = position.coords.latitude + ';' + position.coords.longitude;
        this.submitReport();
      },
      showError(error) {
        console.log(error);
        this.geo = "";
        this.submitReport();
      },
      decodeCoord(coord) {
        debugger;
        let self = this;
        self.geo = coord;
        self.submitReport();
        // $.ajax({
        //   url: 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + coord.latitude +',' + coord.longitude + '&language=iw&key=AIzaSyAfW7SGYXpiNYYSzi4qQDQ1Z-_XMJtsh7I',
        //   method: 'GET',
        //   success: async function (response) {
        //     self.geo = response.results[0] !== undefined ? response.results[0].formatted_address : '';
        //     self.submitReport();
        //   },
        //   error: async function(request, status, errorThrown) {
        //     console.log(errorThrown);
        //     self.geo = "";
        //     self.submitReport();
        //   }
        // });
      }
    },
    beforeMount() {
      // this.getCourses();
      // this.getProjects();
      // this.getLocation();
    },
    mounted() {
      this.getCourses();
      this.getProjects();
    },
    computed: {
      google: gmapApi,
      color() {
        switch (this.status) {
          case "0":
            return '#64B5F6';
          case "1":
            return 'red';
          case "2":
            return 'green';
          case "3":
            return '#EF5350';
          case "4":
            return 'light-green';
          case "5":
            return 'orange';
        }
      }
    },
  };
</script>
<style scoped>
  .card-body {
    overflow: hidden;
  }

  .inline {
    display: inline-block;
  }

  /* .full {
    width: 100%;
  } */

  .card-background {
    opacity: 0.8;
    background-image: url("/static/images/background.jpg");
    background-size: contain;
    transition: opacity .75s ease-in;
  }
  .card-background:hover{
    opacity: 1;
  }
  .card-vehicle > .card-body, .card-driver > .card-body{
    background-color: rgba(0,0,0,0.5);
    border-radius: 10px;
    transition: background-color .75s ease-in;
  }

  .card-vehicle > .card-body:hover, .card-driver > .card-body:hover{
    background-color: rgba(0,0,0,0.66);
  }
  
  .details {
    text-align: center
  }

  label.custom-control-label {
    position: relative;
    padding-right: 1.5rem;
  }

  label.custom-control-label::before, label.custom-control-label::after{
    right: 0;
    left: auto;
  }

  /* The snackbar - position it at the bottom and in the middle of the screen */
#snackbar {
  visibility: hidden; /* Hidden by default. Visible on click */
  min-width: 250px; /* Set a default minimum width */
  margin-left: -125px; /* Divide value of min-width by 2 */
  background-color: #333; /* Black background color */
  color: #fff; /* White text color */
  text-align: center; /* Centered text */
  border-radius: 2px; /* Rounded borders */
  padding: 16px; /* Padding */
  position: fixed; /* Sit on top of the screen */
  z-index: 1; /* Add a z-index if needed */
  left: 50%; /* Center the snackbar */
  bottom: 30px; /* 30px from the bottom */
}

/* Show the snackbar when clicking on a button (class added with JavaScript) */
#snackbar.show {
  visibility: visible; /* Show the snackbar */
  /* Add animation: Take 0.5 seconds to fade in and out the snackbar.
  However, delay the fade out process for 2.5 seconds */
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

/* Animations to fade the snackbar in and out */
@-webkit-keyframes fadein {
  from {bottom: 0; opacity: 0;}
  to {bottom: 30px; opacity: 1;}
}

@keyframes fadein {
  from {bottom: 0; opacity: 0;}
  to {bottom: 30px; opacity: 1;}
}

@-webkit-keyframes fadeout {
  from {bottom: 30px; opacity: 1;}
  to {bottom: 0; opacity: 0;}
}

@keyframes fadeout {
  from {bottom: 30px; opacity: 1;}
  to {bottom: 0; opacity: 0;}
}

.container {
  margin: 25px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Home.vue